export default __webpack_public_path__ + "src/assets/facebook.04736560d4c1facc4421a147d2d8cb02.svg";